module.exports = __webpack_public_path__ + "static/img/kehu-03.7dbf760c.png";